import * as React from 'react'
import * as css from './Share.module.css'
import { EmailShareButton, LinkedinShareButton, TwitterShareButton, FacebookShareButton } from 'react-share'
import { IoPaperPlane } from 'react-icons/io5'
import { FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa'
import useSiteMetadata from 'hooks/siteMetadata'

function ShareUrl(url) {
  return [useSiteMetadata().siteUrl, url].filter(Boolean).join``
}

export const EmailShare = ({ url }) => (
  <EmailShareButton className={css.btn} url={ShareUrl(url)} children={<IoPaperPlane/>} />
)
export const LinkedInShare = ({ url }) => (
  <LinkedinShareButton className={css.btn} url={ShareUrl(url)} children={<FaLinkedin />} />
)
export const TwitterShare = ({ url }) => (
  <TwitterShareButton className={css.btn} url={ShareUrl(url)} children={<FaTwitter/>} />
)
export const FacebookShare = ({ url }) => (
  <FacebookShareButton className={css.btn} url={ShareUrl(url)} children={<FaFacebook/>} />
)

const Share = () => (
  <div>
    <div className="uppercase cps-navy">Share</div>

    <ul className={css.list}>
      <li><EmailShare /></li>
      <li><LinkedInShare /></li>
      <li><TwitterShare /></li>
      <li><FacebookShare /></li>
    </ul>
  </div>
)

export default Share
